/* eslint-disable */
import React, { useState, useEffect } from "react";
import { withRouter } from "react-router";
import { Layout, Popconfirm, Tabs, Menu, Input, Breadcrumb } from "antd";
import TrialPortfolio from "../TrialPortfolio";
import FooterCompt from '../../components/Footer';
import NewScenarioPage from '../NewScenarioPage';
import Literature from '../Literature';
import CompareScenario from '../CompareScenario';
import NewTrial from '../NewTrial';
import ChartSummary from '../ChartSummary';
import { getFullName, getEmail } from "../../utils/auth";
import { logout } from "../../utils/auth";
import AddActivitySoa from '../../components/AddActivitySoa'
import AddActivityIE from '../../components/AddActivityIE'
import AddEndpoint from '../../components/AddEndpoint'
import ShowProtocolAmendment from '../../components/ShowProtocolAmendment'
import iconPwcLogo from "../../assets/pwc-logotype-lockup.png";
import DPAppLayoutWrapper from "src/DigitalProtocolModule"

import "./index.scss";

const { Header, Content ,Footer} = Layout;

const GlobalLayout = (props: any) => {
  const [searchTxt, setSearchTxt] = useState("");
  const [showSearch, setShowSearch] = useState(false)
  const [current, setCurrent] = useState("trial")
  const email = getEmail();
  const fullName = getFullName() ?? "";
  const initials = fullName.split(' ').map((name) => name[0]).join('');
  let content: any;

  function confirm() {
    logout(props.history);
    localStorage.setItem('show-details', 'false')
    localStorage.setItem('trial-id', '')
    localStorage.setItem('trial-detail', '');
    localStorage.setItem('view-details', 'false')
  }

  const renderContent = (searchTxt = "") => {
    const current = props.location.pathname;
    switch (current) {
      case "/trials":
        content = <TrialPortfolio keyWords={searchTxt} showSearch={ showSearch} setShowSearch={(v)=>setShowSearch(v)}/>;
        break;
      case "/scenario":
        content = (
          <NewScenarioPage/>
        );
        break;
      case "/new-trial":
        content = (
          <NewTrial/>
        );
        break;
      case "/dprotocol":      
      case "/dprotocol/endpoints":      
      case "/dprotocol/study-population": 
      case "/dprotocol/arms-cohorts":
      case "/dprotocol/soa":
      case "/dprotocol/soa-details":
      case "/dprotocol/soa-details/add-activity-soa":
        content = (<DPAppLayoutWrapper pathName={current}/>)
        break;
      case "/literature":
        content = (
          <Literature/>
        );
        break;
      case "/compare-scenario":
      content = (
        <CompareScenario/>
      );
         break;
      case "/add-activity-soa":
        content = (
          <AddActivitySoa />
        )
        break;
      case "/add-activity-ie":
        content = (
          <AddActivityIE />
        )
        break;
      case "/add-endpoint":
        content = (
          <AddEndpoint />
        )
        break;
      case "/show-pa":
        content = (
          <ShowProtocolAmendment />
        )
        break;
      case "/chart-summary":
        content = (
        <ChartSummary/>
        );
        break;
      default:
        break;
    }
    return content;
  };

  return (
    <Layout className="intell-trial-layout">
      <Header>
        <div className="header-left">
        <div className="pwc-logo-placeholder">
            <img className= "pwc-logo-image" src={iconPwcLogo}  />
        </div>
          <div className="system__info">
            <span className="system__info_title" >
                Intelligent Clinical Trials
              </span>
          </div>
        </div>
        <div className="header-right">
          <div className="user__info">
            <Popconfirm
              className="logout__container"
              title={
                <div className="info__pop">
                  <div className="user__tag">
                    {initials}
                  </div>
                  <div className="username">
                    <div>{fullName}</div>
                    <span>{email}</span>
                  </div>
                </div>
              }
              icon={null}
              placement="bottomLeft"
              onConfirm={confirm}
              okText="Sign out"
              okType="text"
              cancelText={<div className="cancel_btn"></div>}
            >
              <div className="user__tag">
                {initials}
              </div>
            </Popconfirm>
          </div>
        </div>
      </Header>
      <Content>
        {renderContent(searchTxt)}
      </Content>
       <Footer><FooterCompt/></Footer>
    </Layout>
  );
};

export default withRouter(GlobalLayout);
